<template>
  <v-card>
    <div
      class="hogans-modal-header"
      v-bind:style="{ backgroundColor: companyPrimaryColor }"
    >
      <h2>Cast bewerken</h2>
      <div
        class="hogans-modal-header-close"
        @click="closeEditCastDialog()"
      ></div>
    </div>

    <v-alert class="ma-0 pa-2" v-if="feedback" :value="true" type="warning">
      {{ feedback }}
    </v-alert>
    <v-divider></v-divider>
    <v-card-text>
      <v-text-field
        label="Titel"
        v-model="selectedCastItem.title"
        :rules="requiredRules"
        required
      ></v-text-field>

      <div class="upload-cast-image-wrapper clear">
        <div class="upload-image">
          <p>Upload afbeelding</p>
          <div v-if="selectedCastItem.Image" class="logo-upload-preview">
            <v-img
              :src="selectedCastItem.Image"
              aspect-ratio="1"
              class="grey lighten-2"
            >
              <template v-slot:placeholder>
                <v-layout fill-height align-center justify-center ma-0>
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-layout>
              </template>
            </v-img>
            <div v-if="uploading == true" class="upload-bar">
              <p>{{ uploadProgress }} %</p>
              <div
                class="upload-bar-inner"
                v-bind:style="{ backgroundColor: companyPrimaryColor }"
              ></div>
            </div>
          </div>
          <v-btn
            class="ma-0"
            raised
            :color="companyPrimaryColor"
            dark
            @click="onFileSelect"
            >Kies afbeelding</v-btn
          >
          <input
            type="file"
            style="display: none;"
            ref="fileInput"
            accept="image/*"
            @change="onFilePicked"
          />
        </div>
      </div>

      <div class="field-wrapper" style="max-width: 100%; overflow: hidden;">
        <v-tooltip right>
          <template slot="activator">
            <label class="custom-label"
              >Omschrijving
              <v-icon small right :color="companyPrimaryColor"
                >help</v-icon
              ></label
            >
          </template>
          <span style="color: #fff;"
            >Omschrijving van Cast voor gebruikers.</span
          >
        </v-tooltip>
        <ckeditor
          type="classic"
          :upload-adapter="UploadAdapter"
          v-model="selectedCastItem.description"
          :config="editorConfig"
        ></ckeditor>
      </div>

      <v-container style="padding: 0">
        <v-layout row wrap style="padding: 10px 0">
          <v-flex xs6>
            <v-text-field
              style="margin: 0 0 15px 0;"
              label="Auteur"
              v-model="selectedCastItem.uploadedBy"
              :rules="requiredRules"
              hint="Wie heeft de cast geupdate?"
              persistent-hint
              required
            >
            </v-text-field>
          </v-flex>
          <v-flex xs6 style="padding: 0 0 0 15px;">
            <v-text-field
              style="margin: 0 0 15px 0;"
              label="Afspeeltijd"
              v-model.number="selectedCastItem.delay"
              type="number"
              onkeydown="return event.keyCode !== 69"
              suffix="seconden"
              :rules="requiredRules"
              required
            >
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap style="padding: 10px 0">
          <v-flex xs6>
            <v-menu
              ref="startDateDialog"
              :close-on-content-click="false"
              v-model="startDateDialog"
              lazy
              transition="scale-transition"
              full-width
              max-width="290px"
              min-width="290px"
            >
              <v-text-field
                :color="companyPrimaryColor"
                slot="activator"
                v-model="startDateFormatted"
                label="Startdatum"
                hide-details
                readonly
              ></v-text-field>
              <v-date-picker
                :color="companyPrimaryColor"
                v-model="selectedCastItem.startDate"
                :min="today"
                :show-current="true"
                no-title
                @input="startDateDialog = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs6 style="padding: 0 0 0 15px;">
            <v-menu
              ref="endDateDialog"
              :close-on-content-click="false"
              v-model="endDateDialog"
              lazy
              transition="scale-transition"
              full-width
              max-width="290px"
              min-width="290px"
            >
              <v-text-field
                :color="companyPrimaryColor"
                slot="activator"
                v-model="endDateFormatted"
                label="Einddatum"
                hide-details
                readonly
              ></v-text-field>
              <v-date-picker
                :color="companyPrimaryColor"
                v-model="selectedCastItem.endDate"
                :min="today"
                :show-current="true"
                no-title
                @input="endDateDialog = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>
      </v-container>

      <v-switch
        :color="companyPrimaryColor"
        v-model="selectedCastItem.published"
        class="pa-0"
        hide-details
      >
        <template slot="label">
          <span style="color: #333; margin-right: 5px;">Publiceren</span>
          <v-tooltip class="ma-0 pa-0" right>
            <v-icon small :color="companyPrimaryColor" slot="activator"
              >help</v-icon
            >
            <span style="color: #fff;"
              >Bericht wordt alleen getoond aan gebruikers als deze gepubliceerd
              is.</span
            >
          </v-tooltip>
        </template>
      </v-switch>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <div class="hogans-modal-footer clear">
        <v-btn
          class="modal-button-cancel"
          outline
          depressed
          color="#8B93A6"
          @click="closeEditCastDialog()"
          >Annuleren</v-btn
        >
        <v-btn
          class="modal-button-next"
          :dark="changed"
          round
          :color="companyPrimaryColor"
          :disabled="!changed"
          @click="updateCast()"
          >Wijzigingen opslaan<v-icon right dark
            >arrow_forward_ios</v-icon
          ></v-btn
        >
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import db from "../../firebase/init";
import firebase from "firebase/compat/app";
import { Chrome } from "vue-color";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import platform from "platform";

export default {
  name: "edit-cast-form",
  props: {
    selectedCastItem: Object,
    selectedCastItemOriginal: Object,
  },

  data() {
    return {
      editorConfig: {
        toolbar: [
          "heading",
          "bold",
          "italic",
          "bulletedList",
          "numberedList",
          "|",
          "link",
          "ImageUpload",
          "|",
          "insertTable",
          "|",
          "undo",
          "redo",
        ],
        table: {
          contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
        },
      },
      startDateDialog: false,
      endDateDialog: false,
      valid: false,
      requiredRules: [(v) => !!v || "Dit veld is verplicht"],
      valid: true,
      filename: null,
      image: null,
      feedback: null,
      uploading: false,
      uploadProgress: null,
      file: {},
    };
  },

  created() {
    // Vandaag als maximale datum instellen
    this.today = moment().format("YYYY-MM-DD");
  },

  methods: {
    closeEditCastDialog() {
      // Dialog sluiten
      this.$emit("editCastDialogChange", false);
      this.feedback = null;
    },

    onFileSelect() {
      // Browser venster openen om bestanden te selecteren
      this.$refs.fileInput.click();
    },

    onFilePicked(event) {
      // Afbeelding selecteren en inladen
      const files = event.target.files;
      this.file = files[0];
      let filename = files[0].name;
      this.filename = filename;
      console.log("files: " + filename);
      if (filename.lastIndexOf(".") <= 0) {
        this.feedback = "Voeg een geldig bestand toe.";
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.selectedCastItem.Image = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.image = files[0];
      this.feedback = null;
    },

    UploadAdapter(loader) {
      let token = Math.random()
        .toString(36)
        .substr(2);
      this.loader = loader;

      let company = "hogans";
      let imageUrl = "";
      loader.file.then((response) => {
        this.upload = () => {
          return new Promise((resolve, reject) => {
            const file = response;
            const filename = response.name;

            const ext = filename.slice(filename.lastIndexOf("."));
            const fileUrl = "wysiwyg/" + filename + "-" + token + ext;

            let uploadTask = firebase
              .storage()
              .ref(fileUrl)
              .put(file);

            uploadTask.on(
              "state_changed",
              (taskSnapshot) => {},
              (error) => {
                console.error(error);
                reject();
              },
              () => {
                uploadTask.snapshot.ref
                  .getDownloadURL()
                  .then((url) => {
                    imageUrl = url;
                    resolve();
                  })
                  .catch((error) => {
                    reject();
                  });
              },
            );
          }).then(() => {
            return {
              default: imageUrl,
            };
          });
        };
      });
    },

    updateCast() {
      this.feedback = null;
      if (
        this.selectedCastItem.Image &&
        this.selectedCastItem.description &&
        this.selectedCastItem.title
      ) {
        db.collection("Casting")
          .doc(this.selectedCastItem.id)
          .update({
            title: this.selectedCastItem.title,
            description: this.selectedCastItem.description,
            published: this.selectedCastItem.published,
            startDate: new Date(this.selectedCastItem.startDate),
            endDate: new Date(this.selectedCastItem.endDate),
            company: this.selectedCastItem.company,
            uploadedBy: this.selectedCastItem.uploadedBy,
            Image: this.selectedCastItem.Image,
            delay: this.selectedCastItem.delay * 1000,
            createDate: this.today,
          })
          .then(async (docRef) => {
            if (this.filename) {
              await this.uploadCastImage(this.selectedCastItem.id);
            }
          })
          .then(() => {
            db.collection("log").add({
              time: new Date(),
              logType: "info",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              software: String(platform.os),
              browser: platform.name + " " + platform.version,
              pillarrrVersion: this.$store.state.version,
              action:
                "Pillarrr nieuws aangepast: " +
                this.selectedCastItemOriginal.title,
              extra:
                "<b>ORIGINELE GEGEVENS</b><br>" +
                "<b>Type</b>: " +
                this.selectedCastItemOriginal.title +
                "<br>" +
                "<b>Omschrijving</b>: " +
                this.selectedCastItemOriginal.description +
                "<br>" +
                "<br>" +
                "<b>Gepubliceerd</b>: " +
                this.selectedCastItemOriginal.published +
                "<br><br>" +
                "<b>AANGEPASTE GEGEVENS</b><br>" +
                "<b>Type</b>: " +
                this.selectedCastItem.title +
                "<br>" +
                "<b>Omschrijving</b>: " +
                this.selectedCastItem.description +
                "<br>" +
                "<br>" +
                "<b>Gepubliceerd</b>: " +
                this.selectedCastItem.published,
            });
          })
          .then(() => {
            this.$emit("updateData");
            this.closeEditCastDialog();
          });
      } else {
        this.feedback = "Vul alle velden in om de wijzigingen op te slaan.";
      }
    },

    uploadCastImage(docId) {
      // Afbeelding uploaden en News doc updaten
      return new Promise((resolve, reject) => {
        console.log("start storen");
        const file = this.file;
        const filename = this.filename;
        const ext = filename.slice(filename.lastIndexOf("."));
        const fileUrl = "newsimages/" + docId + ext;
        this.uploading = true;
        let uploadTask = firebase
          .storage()
          .ref(fileUrl)
          .put(file);

        uploadTask.on(
          "state_changed",
          (taskSnapshot) => {
            var progress = Math.ceil(
              (taskSnapshot.bytesTransferred / taskSnapshot.totalBytes) * 100,
            );
            this.uploadProgress = progress;
          },
          (error) => {
            console.log(error);
            reject();
          },
          () => {
            console.log("The upload is compleet");
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then((url) => {
                db.collection("Casting")
                  .doc(docId)
                  .update({
                    Image: url,
                  })
                  .then(() => {
                    resolve();
                    this.uploading = false;
                    this.uploadProgress = null;
                  })
                  .catch((error) => {
                    reject();
                    this.uploading = false;
                    this.uploadProgress = null;
                  });
              })
              .catch((error) => {
                reject();
                this.uploading = false;
                this.uploadProgress = null;
              });
          },
        );
      });
    },

    formatDate(date) {
      // Datum omvormen naar Europese leesbare datum
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
  },

  computed: {
    startDateFormatted() {
      // Datum omvormen naar Europese leesbare datum
      return this.formatDate(this.selectedCastItem.startDate);
    },

    endDateFormatted() {
      // Datum omvormen naar Europese leesbare datum
      return this.formatDate(this.selectedCastItem.endDate);
    },

    changed() {
      // Kijken of content veranderd is
      if (
        _.isEqual(this.selectedCastItem, this.selectedCastItemOriginal) == false
      ) {
        return true;
      } else {
        return false;
      }
    },

    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
  },
};
</script>

<style>
.custom-label {
  font-size: 16px;
  padding: 15px 0 5px;
  display: inline-block;
}

.upload-cast-image-wrapper {
  padding: 20px 0;
}
</style>
